const getOrderStatus = (detailsList, orderNumber) => {
  const orderDetailsList = detailsList.filter(d => d.codigoPedido === parseInt(orderNumber, 10))

  // Recuperar último status
  const latestDetails = orderDetailsList.reduce(
    (latest, details) => {
      return latest && details.dataEntrega < latest.dataEntrega ? latest : details
    },
    { dataEntrega: 0, statusPedido: 'Processado' }
  )

  return latestDetails.statusPedido
  // verificar se existe algum status diferente de enviado, inpendente da data (este registro tem precedencia)
  // Isto trata alguns casos de dados errados onde a data de entrega é inferior a data de envio
  // const entregaDetails = orderDetailsList.find(d => d.statusPedido !== 'ENVIADO')
  // return entregaDetails ? entregaDetails.statusPedido : latestDetails.statusPedido
}

export const transformOrders = ({ data }, type) => {
  const { buscarPedido: orders, buscarEntrega: detailsQuery, temRecarga: recargaQuery } = data
  const { status: temRecarga } = recargaQuery
  const { arsMestre: detailsList } = detailsQuery

  let paymentStatus = 'Pedido Realizado'

  if (type === 'pre') {
    paymentStatus = temRecarga ? 'Pagamento Aprovado' : 'Aguardando pagamento'
  }

  return orders.map(order => {
    const date = order.data || ''
    const [year, month, day] = date.split('-')
    const newDate = date && day ? `${day}/${month}/${year}` : date

    const ret = {
      paymentStatus,
      number: order.pedido,
      date: newDate,
      status: getOrderStatus(detailsList, order.pedido)
    }
    return ret
  })
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/orders.js